// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"2c78230e","232":"fe57e2ef","320":"52ab9c66","348":"b82d2a3e","808":"52ab9c66"}[chunkId] + ".chunk.css";
};